import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rescigo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve the correct login page for the current URL on a 401.
// Strict rule: only auto-redirect to /adentry when the user is *inside the
// admin console*. Other portals each have their own login screen.
function resolveLoginUrlForCurrentPath(path) {
  // Already on a login screen? Don't redirect — let the page show its
  // own error toast. This guards against a `?next=` ping-pong loop.
  const LOGIN_PAGES = [
    "/adentry", "/me/login", "/staff-app/login", "/gov/login",
    "/service-partner/login", "/delivery-app/login", "/partner/login",
  ];
  if (LOGIN_PAGES.some(p => path === p || path.startsWith(p + "?"))) return null;

  // Portal-aware routing: each portal's pages bounce to their own login.
  if (path.startsWith("/me"))              return "/me/login";
  if (path.startsWith("/staff-app"))       return "/staff-app/login";
  if (path.startsWith("/gov"))             return "/gov/login";
  if (path.startsWith("/service-partner")) return "/service-partner/login";
  if (path.startsWith("/delivery-app"))    return "/delivery-app/login";
  if (path.startsWith("/training"))        return null;  // training has its own magic-link flow

  // Public marketing routes — never auto-redirect anywhere
  const PUBLIC_PREFIXES = ["/", "/about", "/contact", "/government",
                             "/for-government", "/for-companies", "/training",
                             "/news", "/privacy", "/terms", "/refund", "/sdg2030"];
  if (PUBLIC_PREFIXES.some(p => path === p || path.startsWith(p + "/"))) return null;

  // Default: it's an admin-console route. Per access-control rule, never
  // auto-redirect to /adentry — that page is direct-entry only. Send the
  // user back to the marketing home instead.
  return "/";
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const target = resolveLoginUrlForCurrentPath(window.location.pathname);
      if (target) {
        localStorage.removeItem("rescigo_token");
        localStorage.removeItem("rescigo_user");
        window.location.href = target;
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join("; ");
  return String(d);
}
